
// PayButton.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PayButton({ cart }) {
  const navigate = useNavigate();
  const { user, authLoaded } = useAuth();

  const handleCheckout = () => {
    // Wait for auth status to load
    if (!authLoaded) return;

    if (cart.length === 0) {
      navigate('/');
      return;
    }

    if (!user) {
      // Server-based login flow — store intent on the server if needed
      navigate('/login');
    } else {
      navigate('/shipping');
    }
  };

  return (
    <div style={{ marginTop: '15px', textAlign: 'right' }}>
      <button
        style={{
          backgroundColor: '#f0c14b',
          border: '1px solid #a88734',
          color: '#111',
          padding: '12px 20px',
          fontSize: '16px',
          fontWeight: 'bold',
          borderRadius: '8px',
          boxShadow: '0 2px 3px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          width: '100%',
          maxWidth: '300px',
        }}
        onClick={handleCheckout}
        disabled={!authLoaded}
      >
        Proceed to Checkout
      </button>
    </div>
  );
}

export default PayButton;










